export default __webpack_public_path__ + "17a3656ce48b2963a315b6f94bed400a.png";